import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import { trakrefFontFamily } from "../../utils";
import { White } from "../../color_utils";

export default function CustomTooltip({ title, children, ...rest }) {
  return (
    <Tooltip
      title={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: White }}>
          {title}
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#344054",
            fontSize: "12px",
            fontFamily: trakrefFontFamily,
            '& .MuiTooltip-arrow': {
              color: "#344054",
            },
          },
        },
      }}
      arrow
      {...rest}
    >
      {children}
    </Tooltip>
  );
}
